export function TickSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
      <path
        d="M1.33301 6.33276L3.66634 8.6661L10.6663 1.33276"
        stroke="#896145"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
